﻿import React from 'react';
import { styled } from '@mui/material/styles';

// HOC typed with recommended typing from: https://react-typescript-cheatsheet.netlify.app/docs/hoc/

type PropsAreEqual<P> = (
  prevProps: Readonly<P>,
  nextProps: Readonly<P>
) => boolean;

const withCapitalized = <P extends {}>(
  component: {
    (props: P): Exclude<React.ReactNode, undefined>;
    displayName?: string;
  },
  propsAreEqual?: PropsAreEqual<P> | false,

  componentName = component.displayName ?? component.name
): {
  (props: P): React.JSX.Element;
  displayName: string;
} => {

  const StyledComponent = styled(component as React.ComponentType<P>)(() => ({
    textTransform: 'capitalize',
  }));

  function WithCapitalized(props: P) {
    return <StyledComponent {...props} />;
  }

  WithCapitalized.displayName = `withCapitalized(${componentName})`;

  const wrappedComponent = propsAreEqual === false ? WithCapitalized : React.memo(WithCapitalized, propsAreEqual);

  //copyStaticProperties(component, wrappedComponent);

  return wrappedComponent as typeof WithCapitalized
};

export { withCapitalized }